import { PlusCircleIcon } from "@heroicons/react/20/solid";

export default function AddIcon({ onClick }) {
  return (
    <PlusCircleIcon
      className="w-20 h-20 cursor-pointer"
      fill="green"
      onClick={onClick}
    />
  );
}
